<template>
  <div class="support-context-summary">
    <div
      class="support-context-summary__row"
      :class="{ 'support-context-summary__row--highlight': item[2] }"
      v-for="item in rows"
      :key="item[0]"
    >
      <span>{{ item[0] }}</span>
      <strong>{{ item[1] }}</strong>
    </div>
  </div>
</template>

<script>
import { getEnvironmentText } from "../services/supportContext";

export default {
  name: "SupportContextSummary",
  props: {
    context: {
      type: Object,
      required: true,
    },
  },
  computed: {
    rows() {
      return getEnvironmentText(this.context);
    },
  },
};
</script>

<style lang="scss" scoped>
.support-context-summary {
  border: 1px solid #e5e7eb;
  border-radius: 8px;
  overflow: hidden;
  background: #fff;
}

.support-context-summary__row {
  display: grid;
  grid-template-columns: 145px 1fr;
  gap: 12px;
  padding: 9px 12px;
  border-bottom: 1px solid #edf0f2;
  font-size: 13px;

  &:last-child {
    border-bottom: 0;
  }

  span {
    color: #667085;
  }

  strong {
    color: #1f2937;
    font-weight: 600;
    min-width: 0;
    overflow-wrap: anywhere;
  }
}

.support-context-summary__row--highlight {
  background: #fff7ed;

  span,
  strong {
    color: #9a3412;
  }
}

@media screen and (max-width: 560px) {
  .support-context-summary__row {
    grid-template-columns: 1fr;
    gap: 2px;
  }
}
</style>
